// API基础URL配置
// 开发环境使用本地服务器，生产环境使用同源相对路径（nginx 统一代理 /api）
const getApiBaseUrl = () => {
  const currentHost = window.location.hostname;

  // 如果通过环境变量明确设置了API URL，则使用它
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // 如果是开发环境或本地访问
  if (process.env.NODE_ENV === 'development' || currentHost === 'localhost') {
    return 'http://localhost:5000/api';
  }

  // 生产环境：同源相对路径，自动适配任何域名/IP/协议
  return '/api';
};

export const API_BASE_URL = getApiBaseUrl();

// 其他全局配置
export const APP_NAME = '小说AI创作平台';
export const APP_VERSION = '1.0.0';

// 导出默认配置
export default {
  API_BASE_URL,
  APP_NAME,
  APP_VERSION
}; 